
$(document).ready(function() {


    const displayArrow = (id) => {

        const current = $('#caroussel-' + id).scrollLeft()
        const itemWidth = $('.myGridItemCollectionClothe').outerWidth(true) ;
        const containerWidth = $('#caroussel-' + id).outerWidth(true);
        const slideNumber = $('#caroussel-' + id + " li").length;
        const maxScroll = itemWidth * slideNumber - containerWidth

        if(current >= maxScroll - itemWidth/2){
            $("#arrow-next-" + id).css("display","none");
        }
        if(current <= maxScroll - itemWidth/2){
            $("#arrow-next-" + id).css("display","block");
        }
        
        current == 0 ? $("#arrow-prev-" + id).css("display","none") : $("#arrow-prev-" + id).css("display","block");
       
    }

const caroussels = $("[id^=caroussel]")
 const arrayC = caroussels.each(function(){
     const id = $(this).attr("section-id")
     displayArrow(id);

     $("#arrow-next-" + id).on("click", function() {  
        displayArrow(id);    
        $('#caroussel-' + id).scrollLeft(300 + $('#caroussel-' + id).scrollLeft())
       })
       
       $("#arrow-prev-" + id).on("click", function() {
        displayArrow();
        $('#caroussel-' + id).scrollLeft($('#caroussel-' + id).scrollLeft() - 300)   
    })

    $('#caroussel-' + id).on("scroll", function(){
        displayArrow(id);
    })

     })
})






// const displayArrow = (id) => {

//     const current = $('.myGridCollectionClothe').scrollLeft()
//     const scrollWidth = $('.myGridCollectionClothe').width();
//     if(current - 200>= scrollWidth){
//         $("#arrow-next").css("display","none");
//     }
//     if(current <= scrollWidth){
//         $("#arrow-next").css("display","block");
//     }
    
//     current == 0 ? $("#arrow-prev").css("display","none") : $("#arrow-prev").css("display","block");
   
// }
// $("#arrow-next").on("click", function() {  
// displayArrow();    
// $('.myGridCollectionClothe').scrollLeft(300 + $('.myGridCollectionClothe').scrollLeft())
// })

// $("#arrow-prev").on("click", function() {
// displayArrow();
// $('.myGridCollectionClothe').scrollLeft($('.myGridCollectionClothe').scrollLeft() - 300)   
// })

// $('.myGridCollectionClothe').on("scroll", function(){
//     displayArrow();
// })
